import { render, staticRenderFns } from "./QuestionsBox.vue?vue&type=template&id=3aaac13e&scoped=true&"
import script from "./QuestionsBox.vue?vue&type=script&lang=js&"
export * from "./QuestionsBox.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsBox.vue?vue&type=style&index=0&id=3aaac13e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaac13e",
  null
  
)

export default component.exports